import { toClassNames } from '@/utils';

type AvartarIconProps = React.SVGProps<SVGSVGElement> & {
  bgClassName: string;
};

export const AvatarIcon: React.FC<AvartarIconProps> = ({ className, bgClassName }) => (
  <svg
    width="33"
    height="32"
    viewBox={`0 0 33 32`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={toClassNames(className)}
  >
    <path
      className={toClassNames(bgClassName)}
      d="M0.5 16C0.5 7.16344 7.66344 0 16.5 0C25.3366 0 32.5 7.16344 32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.5 24.8366 0.5 16Z"
      fill="currentColor"
    />
    <path
      className={toClassNames(className)}
      d="M6.6776 19.983C6.31488 24.3162 14.5761 25.3334 16.6079 25.3334C18.7455 25.3334 27.0868 24.2027 26.5679 19.983C26.5072 19.4912 26.3265 18.958 26.0025 18.3798C25.2448 17.0296 24.9079 15.8291 24.6123 14.7732C24.4458 14.182 24.2934 13.636 24.0856 13.1364C23.9101 11.0789 22.991 6.76623 21.5582 6.74041C20.8508 6.72751 19.5729 8.12159 18.7481 9.83064C17.3514 9.59958 15.8127 9.55699 14.4574 9.79192C13.6338 8.06609 12.343 6.65393 11.6305 6.66684C10.2286 6.69136 9.31862 10.8207 9.11596 12.926C8.90556 13.4178 8.74162 13.9729 8.55704 14.6041C8.25369 15.6393 7.88968 16.8798 7.1552 18.3798C6.87122 18.9593 6.7202 19.4924 6.67889 19.983"
      fill="currentColor"
    />
  </svg>
);
